import { Button } from '@chakra-ui/react';
import React from 'react';

export enum SubtleButtonColor {
    GRAY,
    RED,
    GREEN,
    BLUE,
}

interface SubtleButtonProps {
    text: string;
    function?: () => void;
    color?: SubtleButtonColor;
}

const SubtleButton: React.FC<SubtleButtonProps> = (props) => {
    const colorMap = {
        [SubtleButtonColor.RED]: "red.500",
        [SubtleButtonColor.GREEN]: "green.500",
        [SubtleButtonColor.BLUE]: "blue.500",
        [SubtleButtonColor.GRAY]: "gray.500",
    };

    const color = props.color
        ? colorMap[props.color]
        : "gray.500";

    return (
        <Button
            onClick={props.function}
            variant="outline"
            borderColor={color}
            color={color}
            _hover={{ bg: color, color: "white" }}
            _active={{ bg: `${color.split(".")[0]}.600`, color: "white" }}
            borderRadius="md"
            padding="8px 16px"
            fontSize="sm"
            marginTop={4}
        >
            {props.text}
        </Button>
    );
};

export default SubtleButton;